<div [id]="unicornAnimationDivId" class="animation-unicorn" *ngIf="item.backgroundAnimation"></div>
<ng-container [ngSwitch]="item.node">
  <ng-template #mediaTemplate></ng-template>
  <ng-template #iframeTemplate></ng-template>
  <ng-template #image>
    <div
      (mouseout)="isHovered = false"
      (mouseover)="isHovered = true"
      [item]="item"
      [blockStyles]="blockStyles"
      [isHovered]="isHovered"
      app-image-block
    ></div>
  </ng-template>

  <ng-container *ngSwitchCase="blockNodeEnum.DIV_NODE">
    <ng-container *ngIf="!isSpecialBlock">
      <div
        app-block-container
        *ngIf="item.children.length"
        [disableTabIndex]="disableTabIndex"
        [children]="item.children"
      ></div>
    </ng-container>

    <ng-container *ngIf="isSpecialBlock">
      <ng-container *ngIf="wrappedByContainer; else single">
        <div
          *canShow="item.action"
          [action]="item.action"
          [appClickableBlock]="item"
          [item]="item.specialBlock"
          app-special-block-container
        ></div>
      </ng-container>

      <ng-template #single>
        <div
          [action]="item.action"
          [item]="item"
          [extraData]="extraData"
          special-block
        ></div>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="blockNodeEnum.IFRAME_NODE">
    <div appIframeBlock [innerHTML]="iframeContent"></div>
  </ng-container>

  <ng-container *ngSwitchCase="blockNodeEnum.IFRAME_PARENT">
    <app-iframe-code
      [styleIfameParent]="styleIfameParent"
      [item]="item.children[0]"
    ></app-iframe-code>
  </ng-container>

  <ng-container *ngSwitchCase="blockNodeEnum.IFRAME_SCRIPT">
    <div>
      <app-scrypt [item]="item"></app-scrypt>
    </div>

  </ng-container>

  <ng-container *ngSwitchCase="blockNodeEnum.VIDEO_NODE">
    <ng-container *ngIf="!isSpecialBlock">
      <div
        *ngFor="let child of item.children"
        [appClickableBlock]="child"
        [class]="child.uId"
        [item]="child"
        app-block
      ></div>
    </ng-container>

    <ng-container *ngIf="isSpecialBlock">
      <div
        *canShow="item.action"
        [action]="item.action"
        [appClickableBlock]="item"
        [item]="item.specialBlock"
        app-special-block-container
      ></div>
    </ng-container>
  </ng-container>

  <div
    *ngSwitchCase="blockNodeEnum.PARAGRAPH_NODE"
    [item]="item"
    app-link
    classname="text-link editeable"
    class="text-link editeable"
    [attr.tabindex]="parseTabindex()"
  >
    <ng-container *ngIf="shouldUseTextCollapse(); else defaultParagraph">
      <app-text-collapse
        style="width: 100%"
        [content]="item.content"
        [maxLength]="getTextCollapseMaxLength()"
      ></app-text-collapse>
    </ng-container>
    <ng-template #defaultParagraph>
      <p appEditableBlock appEditableText [innerHTML]="itemContent | safeHtml" class="paragraph ql-editor"></p>
    </ng-template>
  </div>

  <div
    *ngSwitchCase="blockNodeEnum.ANCHOR_NODE"
    [item]="item"
    [routerLinkActiveParent]="item.uId"
    app-link
    classname="text-link"
  >
    <ng-container *ngIf="shouldUseTextCollapse(); else defaultAnchor">
      <app-text-collapse
        style="width: 100%"
        [content]="item.content"
        [maxLength]="getTextCollapseMaxLength()"
      ></app-text-collapse>
    </ng-container>
    <ng-template #defaultAnchor>
      <p>{{ itemContent }}</p>
    </ng-template>
  </div>

  <div
    *ngSwitchCase="blockNodeEnum.HEADING_NODE"
    [item]="item"
    app-link
    classname="text-link"
    [attr.tabindex]="
      canAddTabIndexToChild ? item.tabindex : null
    "
  >
    <ng-container *ngIf="shouldUseTextCollapse(); else defaultHeading">
      <app-text-collapse
        style="width: 100%"
        [content]="item.content"
        [maxLength]="getTextCollapseMaxLength()"
      ></app-text-collapse>
    </ng-container>
    <ng-template #defaultHeading>
      <span appEditableBlock appEditableText [item]="item" [content]="itemContent" app-heading></span>
    </ng-template>
  </div>

  <div
    appEditableImage
    *ngSwitchCase="blockNodeEnum.IMAGE_NODE"
    [item]="item"
    app-link
    classname="image__content"
  >
    <ng-container *ngTemplateOutlet="image"></ng-container>
  </div>


  <div
    (mouseout)="isHovered = false"
    (mouseover)="isHovered = true"
    *ngSwitchCase="blockNodeEnum.SVG_NODE"
    [item]="item"
    app-link
    classname="image__content"
  >
    <div
      app-svg-block
      [isHovered]="isHovered"
      [item]="item"
      [blockStyles]="blockStyles"
      class="svg"
    ></div>
  </div>

  <ng-container *ngSwitchCase="blockNodeEnum.NAV_NODE">
    <div
      *ngFor="let child of item.children"
      [class]="child.uId"
      [item]="child"
      app-block
    ></div>
  </ng-container>

  <ng-container *ngSwitchCase="blockNodeEnum.SNIPPET_NODE">
    <div
      *ngIf="!item.image; else image"
      [item]="item"
      app-link
      classname="text-link"
      [class.full-width]="item.image"
      data-node="SNIPPET_NODE"
      [attr.tabindex]="
        canAddTabIndexToChild ? item.tabindex : null
      "
    >
      <div app-snippet-block [item]="item" [blockStyles]="blockStyles"></div>
    </div>
  </ng-container>

  <div

    *ngSwitchCase="blockNodeEnum.ICON_NODE"
    [item]="item"
    app-link
    classname="text-link"
    [attr.tabindex]="
      canAddTabIndexToChild ? item.tabindex : null
    "
  >
    <i
      *ngIf="item.settings.iconType === 'fontawesome'; else material"
      [class]="itemContent"
    ></i>

    <ng-template #material>
      <mat-icon style="width: 100%; height: 100%">{{ getIconName() }}</mat-icon>
    </ng-template>
  </div>

  <div
    *ngSwitchCase="blockNodeEnum.INPUT_TEXT_NODE"
    [item]="item"
    form-field
  ></div>

  <div
    *ngSwitchCase="blockNodeEnum.INPUT_FILE_NODE"
    [item]="item"
    form-field-file
  ></div>

  <div
    *ngSwitchCase="blockNodeEnum.SELECT_NODE"
    [item]="item"
    form-field-select
  ></div>

  <div
    *ngSwitchCase="blockNodeEnum.INPUT_SEARCH_NODE"
    [item]="item"
    [parentStyleEmpty]="item.uId"
    form-field-search
  ></div>

  <div
    *ngSwitchCase="blockNodeEnum.TEXTAREA_NODE"
    [item]="item"
    form-field-textarea
  ></div>

  <div
    *ngSwitchCase="blockNodeEnum.INPUT_PASSWORD_NODE"
    [item]="item"
    password-field
  ></div>

  <div
    *ngSwitchCase="blockNodeEnum.INPUT_CHECKBOX_NODE"
    [item]="item"
    checkbox-field
  ></div>
</ng-container>
